<template>
    <div class="user_center_page">
        <!-- 顶部用户信息区域 -->
        <div class="user_header">
            <div class="header_title">{{ $t('user.user') }}</div>
            <div class="user_info">
                <div class="user_avatar">
                    <img v-if="userInfo && userInfo.user_icon" :src="userInfo.user_icon" alt="">
                    <img v-else src="../../../src/assets/images/user/top.png" alt="">
                </div>
                <div class="user_details">
                    <div class="detail_item">{{ $t('user.account') }}: {{ userInfo ? userInfo.mobile : '--' }}</div>
                    <div class="detail_item">{{ $t('user.membershipLevel') }}: {{ userInfo ? userInfo.vip_name : '--' }}</div>
                    <div class="detail_item">{{ $t('user.userID') }}: {{ userInfo ? userInfo.uid : '--' }}</div>
                    <div class="detail_item">{{ $t('user.creditScore') }}: {{ userInfo ? userInfo.credit : '0' }}</div>
                </div>
            </div>
        </div>

        <!-- 功能菜单列表 -->
        <div class="menu_list">
            <div class="menu_item" @click="goToPage('balance')">
                <div class="menu_icon record_icon">
                    <img src="../../../src/assets/images/user/item1.png" alt="">
                </div>
                <div class="menu_text">{{ $t('user.balance') }}</div>
                <div class="menu_value">{{ userInfo ? userInfo.money : '0.00' }}</div>
				<div class="menu_value">({{coin}}:{{ userInfo ? (userInfo.money/rate).toFixed(2) : '0.00' }})</div>
            </div>

            <div class="menu_item" @click="goToPage('depositRecord')">
                <div class="menu_icon record_icon">
                    <img src="../../../src/assets/images/user/item2.png" alt="">
                </div>
                <div class="menu_text">{{ $t('user.depositRecord') }}</div>
                <div class="menu_arrow">
                    <img src="../../../src/assets/images/goto.png" alt="">
                </div>
            </div>

            <div class="menu_item" @click="goToPage('withdrawRecord')">
                <div class="menu_icon record_icon">
                    <img src="../../../src/assets/images/user/item2.png" alt="">
                </div>
                <div class="menu_text">{{ $t('user.withdrawRecord') }}</div>
                <div class="menu_arrow">
                    <img src="../../../src/assets/images/goto.png" alt="">
                </div>
            </div>

            <div class="menu_item" @click="goToPage('deposit')">
                <div class="menu_icon deposit_icon">
                    <img src="../../../src/assets/images/user/item4.png" alt="">
                </div>
                <div class="menu_text">{{ $t('user.Deposit') }}</div>
                <div class="menu_arrow">
                    <img src="../../../src/assets/images/goto.png" alt="">
                </div>
            </div>

            <div class="menu_item" @click="goToPage('withdraw')">
                <div class="menu_icon withdraw_icon">
                    <img src="../../../src/assets/images/user/item5.png" alt="">
                </div>
                <div class="menu_text">{{ $t('user.Withdraw') }}</div>
                <div class="menu_arrow">
                    <img src="../../../src/assets/images/goto.png" alt="">
                </div>
            </div>

            <div class="menu_item" @click="goToPage('interest')">
                <div class="menu_icon interest_icon">
                    <img src="../../../src/assets/images/user/item6.png" alt="">
                </div>
                <div class="menu_text">{{ $t('user.InterestEarnings') }}</div>
                <div class="menu_arrow">
                    <img src="../../../src/assets/images/goto.png" alt="">
                </div>
            </div>

            <div class="menu_item" @click="goToPage('bankCard')">
                <div class="menu_icon bank_icon">
                    <img src="../../../src/assets/images/user/item7.png" alt="">
                </div>
                <div class="menu_text">{{ $t('user.myWallet') }}</div>
                <div class="menu_arrow">
                    <img src="../../../src/assets/images/goto.png" alt="">
                </div>
            </div>

            <!-- <div class="menu_item" @click="goToPage('customerService')">
                <div class="menu_icon service_icon">
                    <img src="../../../src/assets/images/user/item8.png" alt="">
                </div>
                <div class="menu_text">{{ $t('user.Customer') }}</div>
                <div class="menu_arrow">
                    <img src="../../../src/assets/images/goto.png" alt="">
                </div>
            </div> -->

            <div class="menu_item" @click="goToPage('loginPassword')">
                <div class="menu_icon password_icon">
                    <img src="../../../src/assets/images/user/item7.png" alt="">
                </div>
                <div class="menu_text">{{ $t('user.LoginPassword') }}</div>
                <div class="menu_arrow">
                    <img src="../../../src/assets/images/goto.png" alt="">
                </div>
            </div>

            <div class="menu_item" @click="goToPage('transactionPassword')">
                <div class="menu_icon password_icon">
                    <img src="../../../src/assets/images/user/item7.png" alt="">
                </div>
                <div class="menu_text">{{ $t('user.PaymentPassword') }}</div>
                <div class="menu_arrow">
                    <img src="../../../src/assets/images/goto.png" alt="">
                </div>
            </div>

            <div class="menu_item" @click="logout">
                <div class="menu_icon logout_icon">
                    <img src="../../../src/assets/images/user/item11.png" alt="">
                </div>
                <div class="menu_text">{{ $t('user.SignOut') }}</div>
                <div class="menu_arrow">
                    <img src="../../../src/assets/images/goto.png" alt="">
                </div>
            </div>
        </div>

        <!-- 底部导航栏 -->
        <FooterTab :activeType="'user'" />
    </div>
</template>

<script>
import FooterTab from '../../components/FooterTab.vue'
import Fetch from '../../utils/fetch'

export default {
    name: "UserCenter",
    components: { FooterTab },
    data() {
        return {
            show_icon_type: 'user',
            userInfo: null, // 存储用户信息
            loading: false, // 加载状态
			lang: this.$i18n.locale || "ja_jp",
			coin:'',
			rate:1,
			currencyOptions: [],
            kefuLoading: false // 客服跳转loading状态
        };
    },
    created() {
        this.$parent.footer("user", false);
        this.show_icon_type = 'user';
        this.getUserInfo();
		// 获取货币汇率
		this.getCurrencyRates();
		this.getCoin();
    },
    methods: {
        // 获取用户信息
        async getUserInfo() {
            try {
                this.loading = true;
                console.log('开始获取用户信息...');
                
                // 检查是否有token，没有token则不请求用户信息
                const token = localStorage.getItem('token');
                if (!token) {
                    console.log('没有token，跳转到登录页');
                    this.$router.replace('/login');
                    return;
                }
                
                // 调用API获取用户信息
                const result = await Fetch('/user/info');
                
                console.log('用户信息API响应:', result);
                
                if (result && result.code === 1) {
                    console.log('用户信息获取成功:', result.data);
                    this.userInfo = result.data;
                    // 将用户信息保存到全局store中
                    this.$store.commit('setUserInfo', result.data);
                } else if (result && result.code === 0) {
                    console.log('用户信息业务提示:', result);
                    // 显示业务提示信息
                    let message = '';
                    if (typeof result.info === 'string') {
                        message = result.info;
                    } else if (typeof result.info === 'object') {
                        const currentLang = localStorage.getItem('lang') || 'zh_hk';
                        message = result.info[currentLang] || result.info.zh_cn || '获取用户信息失败';
                    }
                    console.log('提示信息:', message);
                } else {
                    console.error('用户信息获取失败:', result);
                }
            } catch (error) {
                console.error('获取用户信息出错:', error);
            } finally {
                this.loading = false;
            }
        },
		getCoin() {
			switch(this.lang) {
				case 'ja': this.coin = 'JPY';break;
				case 'zh_hk': this.coin = 'HKD';break;
				case 'en': this.coin = 'USD';break;
				case 'ko': this.coin = 'KRW';break;
				case 'th_th': this.coin = 'THB';break;
				case 'vi_vn': this.coin = 'VND';break;
				case 'ms_my': this.coin = 'MYR';break;
				case 'pt_br': this.coin = 'USD';break;
				default: this.coin = 'USD';break;
			}
			
		},
		
		// 获取货币汇率
		async getCurrencyRates() {
			try {
				console.log('💱 开始获取货币汇率...');
				const result = await Fetch('/index/currency_rates', {
					language: localStorage.getItem('lang') || 'zh_hk'
				});
				
				console.log('💱 货币汇率API响应:', result);
				
				if (result && result.code === 1 && result.data) {
					console.log('✅ 货币汇率获取成功');
					
					// 转换API数据为前端需要的格式
					this.currencyOptions = result.data.map(rate => ({
						value: rate.currency_name,
						label: rate.currency_name,
						rate: parseFloat(rate.exchange_rate),
						code: rate.currency_code
					}));
					
					// 设置默认选中的货币（美元）
					const usdOption = this.currencyOptions.find(option => option.code === this.coin);
					if (usdOption) {
						this.rate = usdOption.rate;
					} 
					
					
				} else {
					console.error('❌ 货币汇率获取失败:', result);
					// 使用默认汇率作为兜底
					this.setDefaultCurrencyOptions();
				}
			} catch (error) {
				console.error('💥 获取货币汇率出错:', error);
				// 使用默认汇率作为兜底
				this.setDefaultCurrencyOptions();
			}
		},
		
		// 设置默认货币选项（兜底方案）
		setDefaultCurrencyOptions() {
			console.log('🔄 使用默认货币汇率');
			this.currencyOptions = [
				{ value: this.$t('invest.USD'), label: this.$t('invest.USD'), rate: 7.2, code: 'USD' },
				{ value: this.$t('invest.CNY'), label: this.$t('invest.CNY'), rate: 1.0, code: 'CNY' },
				{ value: this.$t('invest.EUR'), label: this.$t('invest.EUR'), rate: 7.8, code: 'EUR' },
				{ value: this.$t('invest.JPY'), label: this.$t('invest.JPY'), rate: 0.048, code: 'JPY' },
				{ value: this.$t('invest.HKD'), label: this.$t('invest.HKD'), rate: 0.93, code: 'HKD' }
			];
		},
        
        goToPage(pageType) {
            // 跳转到具体页面
            switch(pageType) {
                case 'withdraw':
                    this.$router.push('/withdraw');
                    break;
                case 'deposit':
                    this.$router.push('/deposit');
                    break;
                case 'depositRecord':
                    this.$router.push('/depositRecord');
                    break;
                case 'withdrawRecord':
                    this.$router.push('/withdrawRecord');
                    break;
                case 'interest':
                    this.$router.push('/interestIncome');
                    break;
                case 'bankCard':
                    this.$router.push('/bankCard');
                    break;
                case 'customerService':
                    this.jumpToCustomerService();
                    break;
                case 'loginPassword':
                    this.$router.push('/loginPassword');
                    break;
                case 'transactionPassword':
                    this.$router.push('/transactionPassword');
                    break;
                default:
                    console.log('跳转到页面', pageType);
            }
        },
        // 直接跳转到客服
        jumpToCustomerService() {
            // 防止重复点击
            if (this.kefuLoading) return;
            
            this.kefuLoading = true;
            console.log('用户中心直接跳转客服，获取配置...');
            
            let agent = localStorage.getItem('agent');
            Fetch('/index/webconfig', {agent, type: 'web'}).then(res => {
                if (res.data.kefu_link) {
                    console.log('直接跳转到客服:', res.data.kefu_link);
                    window.location.href = res.data.kefu_link;
                } else {
                    this.$toast('客服配置错误');
                }
            }).catch(err => {
                console.error('获取客服配置失败:', err);
                this.$toast('客服暂时不可用，请稍后重试');
            }).finally(() => {
                this.kefuLoading = false;
            });
        },
        
        logout() {
            // 退出登录逻辑
            console.log('退出登录');
            // 清除store中的用户信息
            this.$store.commit('setLogout');
            // 清除本地存储的token
            localStorage.removeItem('token');
            // 跳转到登录页面
            this.$router.push('/login');
        }
    }
};
</script>

<style lang="less" scoped>
.user_center_page {
    min-height: 100vh;
    background-color: #f7f7f7;
    // padding-bottom: 60px;
}

.user_header {
    background: linear-gradient(135deg, #1890ff, #096dd9);
    padding: 20px 16px 10px;
    color: #fff;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);

    .header_title {
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 20px;
    }

    .user_info {
        display: flex;
        align-items: center;
        gap: 16px;

        .user_avatar {
            width: 50px;
            height: 50px;
            background: rgba(255, 255, 255, 0.2);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
            }

            .avatar_text {
                font-size: 24px;
                color: #fff;
                font-weight: bold;
            }
        }

        .user_details {
            flex: 1;

            .detail_item {
                font-size: 14px;
                margin-bottom: 9px;
                opacity: 0.9;
            }
        }
    }
}

.menu_list {
    background: #fff;
    border-radius: 20px 20px 0 0;
    width: 96%;
    margin: 0 auto;
    margin-top: 15px;
    padding-bottom: 10px;

    .menu_item {
        display: flex;
        align-items: center;
        padding: 16px;
        cursor: pointer;
        transition: background-color 0.2s ease;

        &:first-child {
            border-bottom: 1px solid #f0f0f0;
        }

        &:hover {
            background-color: #f8f9fa;
        }

        .menu_icon {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 16px;

            // &.balance_icon {
            // 	background: #1890ff;
            // }

            // &.record_icon {
            // 	background: #fa8c16;
            // }

            // &.deposit_icon {
            // 	background: #1890ff;
            // }

            // &.withdraw_icon {
            // 	background: #1890ff;
            // }

            // &.interest_icon {
            // 	background: #fa8c16;
            // }

            // &.bank_icon {
            // 	background: #fadb14;
            // }

            // &.service_icon {
            // 	background: #1890ff;
            // }

            // &.password_icon {
            // 	background: #fadb14;
            // }

            // &.logout_icon {
            // 	background: #ff4d4f;
            // }

            img {
                width: 20px;
                height: 20px;
            }

            .icon_symbol {
                color: #fff;
                font-size: 18px;
                font-weight: bold;
            }
        }

        .menu_text {
            flex: 1;
            font-size: 16px;
            color: #323233;
        }

        .menu_value {
            font-size: 16px;
            color: #666;
            margin-right: 8px;
        }

        .menu_arrow {
            color: #ccc;
            font-size: 16px;
            img{
                width: 16px;
            }
        }
    }
}

/* 底部导航栏样式 */
.footer {
    position: fixed;
    margin: 0 auto;
    left: 0;
    right: 0;
    flex: 0 0 48px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: #fff;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
    width: 100%;
    max-width: 750px;
    bottom: 0;
    height: 60px;
    z-index: 4;
}

.footer .footer_item {
    display: flex;
    align-items: center;
    flex-direction: column;
    cursor: pointer;
    color: #55585a;
    width: 60px;
}

.footer .footer_item .footer_icon {
    display: inline-block;
    width: 26px;
    height: 26px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    margin-bottom: 6px;
}

.footer .footer_item .footer_icon.footer_icon_home {
    background-image: url(../../../src/assets/images/tab/shou.png);
}

.footer .footer_item .footer_icon.footer_icon_task {
    background-image: url(../../../src/assets/images/tab/item.png);
}

.footer .footer_item .footer_icon.footer_icon_cart {
    background-image: url(../../../src/assets/images/tab/kefu.png);
}

.footer .footer_item .footer_icon.footer_icon_user {
    background-image: url(../../../src/assets/images/tab/my.png);
}

.footer .footer_item .footer_info {
    font-size: 12px;
}

.footer .footer_item.footer_item_active {
    color: #3775f4;
}
</style>
